import React from "react";

export default function EmailActionButton({ color, data, icon, action, toolTip }) {
	return (
		<button className={`btn btn-sm btn-${color}`} onClick={() => action(data.id)} data-toggle="tooltip" data-placement="top" title={toolTip}>
			<i class={`bi bi-${icon}`}></i>
		</button>
	);
}
